import React, { Component } from 'react';
import {Col, Row, Input, Divider, InputNumber} from 'antd'
import { debounce, isEmpty } from 'lodash';
import { validateProductAndLenderInputNumber } from './utils'
import { LIMIT_PLACEHOLDER, DEFAULT_FUNDING_LIMIT_INPUT_AMOUNT_OBJECT } from '../constants'
import '../fundingLimit.less'
export default class SetupLimitCard extends Component {

    constructor() {
        super();
        this.state = {
            ...DEFAULT_FUNDING_LIMIT_INPUT_AMOUNT_OBJECT
        }
        this.debounceProductLimitChange = debounce(this.debounceProductLimitChange, 300)
    }

    componentDidMount() {
        this.setState({
            inputAmount: this.props.cardValue
        })
    }
    
    debounceProductLimitChange = (action, productCode, targetValue) => {
        this.props.handleProductLimitChange(action, productCode, targetValue)
    }

    handleProductLimitChange = (limitValue) => {
        const {translate} = this.props
        this.setState({
            ...DEFAULT_FUNDING_LIMIT_INPUT_AMOUNT_OBJECT,
            inputAmount: limitValue
        })
        const errorMessage = validateProductAndLenderInputNumber(limitValue, translate)
        if(!isEmpty(errorMessage)){
            this.setState({
                isCurrentInputAmountInvalid: true,
                currentInvalidInputAmountMessage: errorMessage
            })
        }
        const {cardData} =  this.props
        this.debounceProductLimitChange("saveProductLimit", cardData.code, limitValue)
    }

    renderInputNumberComponent = () => {
        const invalidInputClass = this.props.isInvalidInput || this.state.isCurrentInputAmountInvalid ? "setup-limit-input-error" : '';
        return (
            <Row className={`setup-limit-input ${invalidInputClass}`}>
                <InputNumber
                        className='setup-limit-input-style'
                        placeholder={LIMIT_PLACEHOLDER}
                        onChange={this.handleProductLimitChange}
                        value={this.state.inputAmount === -1 ? '' :this.state.inputAmount}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                        parser={value => value.replace(/\$\s?|(\.*)/g, '')}
                    />

            </Row>
        );
        
    };
    renderInputNumberErrorMessage = () => {
        const {isInvalidInput, invalidInputMessage} = this.props
        const {isCurrentInputAmountInvalid, currentInvalidInputAmountMessage} = this.state
        return (
            <>
                { isInvalidInput ? <Row className='setup-limit-input-error'>{invalidInputMessage}</Row>: <></>}
                { isCurrentInputAmountInvalid && !isInvalidInput ? <Row className='setup-limit-input-error'>{currentInvalidInputAmountMessage}</Row>: <></>}
            </>
        );
    }

    render() {
        const { cardData } = this.props;
        return (
            <Col key={cardData.code} tabIndex={cardData.code} span={6}>
                <Row className='setup-limit-title'>
                {cardData.name}
                </Row>
                <Divider/>
                {this.renderInputNumberComponent()}
                {this.renderInputNumberErrorMessage()}
            </Col>
      );
    }
  }